module.exports = __webpack_public_path__ + "img/face93.69479f8d.gif";